export * from './post-template-request.interface';
export * from './post-template-response.interface';
export * from './post-template.shapes';
